<template>
  <router-link :to="location">
    <slot>{{text}}</slot>
  </router-link>
</template>

<script>
export default {
  name: 'PlayerLink',

  props: {
    playerId: {
      type: Number,
      required: true,
    },

    label: {
      type: String,
      default: 'player',
    },
  },

  computed: {
    /** @returns {Object} */
    location() {
      const loc = {
        name: 'player_info',
        params: {
          playerId: this.playerId,
        },
      };
      return loc;
    },

    /** @returns {string} */
    text() {
      const label = this.label;
      const idStr = this.playerId.toString();

      if(label.length > 0) {
        return label + ' ' + idStr;
      } else {
        return idStr;
      }
    },
  },
};
</script>
